import {Directive, forwardRef} from '@angular/core';
import {UntypedFormControl, NG_VALIDATORS, Validator} from '@angular/forms';

function validatePlusFour() {
  return (c: UntypedFormControl) => {
    const plusFourCodeRegex = new RegExp(/^[0-9]{4}$/i);

    if (c.value === undefined || c.value === null || c.value?.length === 0){
      return null;
    }

    return plusFourCodeRegex.test(c.value) ? null : {
      plus4: {
        valid: false
      }
    };
  };
}

@Directive({
  selector: '[appPlus4Validator]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: forwardRef(() => Plus4ValidatorDirective), multi: true}
  ]
})
export class Plus4ValidatorDirective implements Validator {

  validator: Function;

  constructor() {
    this.validator = validatePlusFour();
  }

  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

}
